export default __webpack_public_path__ + "static/AD_9650_rgb-3557af380115362eecd77916265472d7.jpg";